function filterProps(props) {
    return Object.keys(props).reduce(function(acc, key) {
        if (props[key] !== void 0) {
            acc[key] = props[key];
        }
        return acc;
    }, {});
}
export { filterProps }; //# sourceMappingURL=filter-props.js.map
